module.exports = __webpack_public_path__ + "static/media/languages.56aa091e.svg";